import Joi from 'joi';

export const userSchema = Joi.object({
  USERNAME: Joi.string().required(),
  PASSWORD: Joi.string().required(),
  FULL_NAME: Joi.string().required(),
  OKPO: Joi.string().alphanum().required(),
});
